(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["togo-floating"] && !Shopify.designMode) return;
  try {
    
  (() => {
    if (customElements.get('togo-popup')) return;

    const STORAGE_KEY = 'togo_popup_closed';
    const WEEK = 7 * 24 * 60 * 60 * 1000;

    class TogoPopup extends HTMLElement {
      connectedCallback() {
        this.dialog = this.querySelector('dialog');
        if (!this.dialog) return;

        this.abort = new AbortController();
        const { signal } = this.abort;
        this.answers = {};

        this.addEventListener('click', (event) => this.onClick(event), { signal });
        this.dialog.addEventListener(
          'click',
          (event) => {
            if (event.target === this.dialog) this.dialog.close();
          },
          { signal }
        );
        this.dialog.addEventListener('close', () => this.remember(), { signal });

        const posted = this.querySelector('[data-togo-success]') || this.querySelector('.togo-popup__error');
        if (posted) {
          this.open();
          if (!this.querySelector('[data-togo-success]')) this.goTo(4);
          return;
        }

        if (this.dataset.design === 'true') {
          document.addEventListener(
            'shopify:section:select',
            (event) => {
              if (event.detail.sectionId === this.dataset.sectionId) this.open();
            },
            { signal }
          );
          document.addEventListener(
            'shopify:section:deselect',
            (event) => {
              if (event.detail.sectionId === this.dataset.sectionId) this.dialog.close();
            },
            { signal }
          );
          return;
        }

        if (this.seen()) return;

        const delay = Math.max(3, Number(this.dataset.delay) || 10) * 1000;
        this.timer = window.setTimeout(() => this.open(), delay);
        document.addEventListener(
          'mouseout',
          (event) => {
            if (!event.relatedTarget && event.clientY <= 0) this.open();
          },
          { signal }
        );
      }

      disconnectedCallback() {
        this.abort?.abort();
        window.clearTimeout(this.timer);
      }

      seen() {
        try {
          return Date.now() - Number(window.localStorage.getItem(STORAGE_KEY) || 0) < WEEK;
        } catch (error) {
          return false;
        }
      }

      remember() {
        try {
          window.localStorage.setItem(STORAGE_KEY, String(Date.now()));
        } catch (error) {
          /* almacenamiento no disponible */
        }
      }

      open() {
        if (this.dialog.open) return;
        window.clearTimeout(this.timer);
        if (typeof this.dialog.showModal === 'function') this.dialog.showModal();
        else this.dialog.setAttribute('open', '');
      }

      goTo(step) {
        this.querySelectorAll('[data-step]').forEach((el) => {
          el.classList.toggle('is-active', Number(el.dataset.step) === step);
        });
        const active = this.querySelector(`[data-step="${step}"]`);
        active?.querySelector('button, input')?.focus();
      }

      onClick(event) {
        const target = event.target instanceof Element ? event.target : null;
        if (!target) return;

        if (target.closest('[data-togo-close]')) {
          this.dialog.close();
          return;
        }

        const copy = target.closest('[data-togo-copy]');
        if (copy) {
          navigator.clipboard?.writeText(copy.dataset.togoCopy || '');
          copy.textContent = '¡Copiado!';
          return;
        }

        const answer = target.closest('[data-answer]');
        if (!answer) return;

        this.answers[answer.dataset.answer] = answer.dataset.value;
        if (answer.dataset.answer === 'peso') this.dose = answer.dataset.dose || '';

        const step = Number(answer.closest('[data-step]')?.dataset.step || 1);
        if (step === 3) this.fillResult();
        this.goTo(step + 1);
      }

      fillResult() {
        const weight = this.answers.peso || '';
        const title = this.querySelector('[data-togo-result-title]');
        const text = this.querySelector('[data-togo-result-text]');
        const tags = this.querySelector('[data-togo-tags]');

        if (title) {
          title.textContent =
            weight === 'Más de 30 kg'
              ? 'Escríbenos antes de comprar'
              : `Para un perro de ${weight.toLowerCase()}: ${this.dose || 'su dosis según el peso'}`;
        }
        if (text && weight === 'Más de 30 kg') {
          text.textContent = 'Esta fórmula es para perros de menos de 30 kg. Déjanos tu correo y te contamos cuándo llega la versión para razas grandes.';
        }
        if (tags) {
          const extra = Object.entries(this.answers).map(([key, value]) => `${key}: ${value}`);
          tags.value = ['newsletter', 'popup-quiz', ...extra].join(', ');
        }
      }
    }

    customElements.define('togo-popup', TogoPopup);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["togo-product-main"] && !Shopify.designMode) return;
  try {
    
  (() => {
    if (customElements.get('togo-buy-box')) return;

    const formatMoney = (cents) => {
      const pesos = Math.round(Number(cents) / 100);
      return '$' + String(pesos).replace(/\B(?=(\d{3})+(?!\d))/g, '.');
    };

    class TogoBuyBox extends HTMLElement {
      connectedCallback() {
        this.abort = new AbortController();
        const { signal } = this.abort;

        try {
          this.variants = JSON.parse(this.querySelector('[data-togo-variants]').textContent);
        } catch (error) {
          this.variants = [];
        }

        this.weightPos = Number(this.dataset.weightPos);
        this.daysPos = Number(this.dataset.daysPos);

        this.addEventListener(
          'change',
          (event) => {
            if (event.target.matches('[data-togo-weight], [data-togo-days]')) this.update();
          },
          { signal }
        );

        this.setupGallery(signal);
        this.setupSticky();
      }

      disconnectedCallback() {
        this.abort?.abort();
        this.observer?.disconnect();
        if (this.sticky) this.sticky.remove();
        document.body.classList.remove('togo-has-sticky');
      }

      checkedValue(selector) {
        const input = this.querySelector(`${selector}:checked`);
        return input ? input.value : null;
      }

      findVariant(weight, days) {
        return this.variants.find((variant) => {
          const weightOk = this.weightPos < 0 || variant.options[this.weightPos] === weight;
          const daysOk = this.daysPos < 0 || variant.options[this.daysPos] === days;
          return weightOk && daysOk;
        });
      }

      update() {
        const weight = this.checkedValue('[data-togo-weight]');
        const days = this.checkedValue('[data-togo-days]');
        const variant = this.findVariant(weight, days);
        if (!variant) return;

        const idInput = this.querySelector('[data-togo-variant]');
        if (idInput) idInput.value = variant.id;

        this.querySelectorAll('[data-togo-weight], [data-togo-days]').forEach((input) => {
          input.closest('label')?.classList.toggle('is-selected', input.checked);
        });

        const weightInput = this.querySelector('[data-togo-weight]:checked');
        const doseEl = this.querySelector('[data-togo-dose]');
        if (weightInput && doseEl) doseEl.textContent = weightInput.dataset.dose || '';

        this.querySelectorAll('[data-togo-tier]').forEach((card) => {
          const tierVariant = this.findVariant(weight, card.dataset.togoTier);
          if (!tierVariant) return;
          const daysCount = Number(card.dataset.days) || 0;
          const priceEl = card.querySelector('[data-togo-tier-price]');
          const compareEl = card.querySelector('[data-togo-tier-compare]');
          const perDayEl = card.querySelector('[data-togo-tier-perday]');
          const saveEl = card.querySelector('[data-togo-tier-save]');
          if (priceEl) priceEl.textContent = formatMoney(tierVariant.price);
          const hasCompare = tierVariant.compare > tierVariant.price;
          if (compareEl) {
            compareEl.hidden = !hasCompare;
            if (hasCompare) compareEl.textContent = formatMoney(tierVariant.compare);
          }
          if (saveEl) {
            saveEl.hidden = !hasCompare;
            if (hasCompare) {
              const saved = tierVariant.compare - tierVariant.price;
              saveEl.textContent = `Ahorras ${formatMoney(saved)} (${Math.round((saved * 100) / tierVariant.compare)}%)`;
            }
          }
          if (perDayEl && daysCount > 0) {
            perDayEl.textContent = `${formatMoney(Math.floor(tierVariant.price / daysCount / 100) * 100)} al día`;
          }
        });

        const daysCount = parseInt(days, 10) || 0;
        const priceEl = this.querySelector('[data-togo-price]');
        const compareEl = this.querySelector('[data-togo-compare]');
        const perDayEl = this.querySelector('[data-togo-perday]');
        if (priceEl) priceEl.textContent = formatMoney(variant.price);
        if (compareEl) {
          compareEl.hidden = !(variant.compare > variant.price);
          compareEl.textContent = formatMoney(variant.compare);
        }
        if (perDayEl) {
          perDayEl.hidden = daysCount === 0;
          if (daysCount) perDayEl.textContent = `${formatMoney(Math.floor(variant.price / daysCount / 100) * 100)} al día`;
        }

        const cta = this.querySelector('[data-togo-cta]');
        const ctaLabel = this.querySelector('[data-togo-cta-label]');
        if (cta) cta.disabled = !variant.available;
        if (ctaLabel) ctaLabel.textContent = variant.available ? this.dataset.ctaLabel : 'Agotado';

        if (this.sticky) {
          const title = this.sticky.querySelector('[data-togo-sticky-title]');
          const price = this.sticky.querySelector('[data-togo-sticky-price]');
          const button = this.sticky.querySelector('[data-togo-sticky-cta]');
          if (title) title.textContent = [days, weight].filter(Boolean).join(' · ');
          if (price) price.textContent = formatMoney(variant.price);
          if (button) button.disabled = !variant.available;
        }

        if (this.dataset.updateUrl === 'true') {
          const url = new URL(window.location.href);
          url.searchParams.set('variant', variant.id);
          window.history.replaceState(window.history.state, '', url.toString());
        }
      }

      setupGallery(signal) {
        const track = this.querySelector('[data-togo-track]');
        const thumbs = Array.from(this.querySelectorAll('[data-togo-thumb]'));
        if (!track || thumbs.length === 0) return;

        thumbs.forEach((thumb) => {
          thumb.addEventListener(
            'click',
            () => {
              const slide = track.children[Number(thumb.dataset.togoThumb)];
              if (slide) track.scrollTo({ left: slide.offsetLeft - track.offsetLeft, behavior: 'smooth' });
            },
            { signal }
          );
        });

        let frame = 0;
        track.addEventListener(
          'scroll',
          () => {
            cancelAnimationFrame(frame);
            frame = requestAnimationFrame(() => {
              const index = Math.round(track.scrollLeft / Math.max(track.clientWidth, 1));
              thumbs.forEach((thumb, i) => thumb.classList.toggle('is-active', i === index));
            });
          },
          { passive: true, signal }
        );
      }

      setupSticky() {
        const sticky = this.querySelector('[data-togo-sticky]');
        const cta = this.querySelector('[data-togo-cta]');
        if (!sticky || !cta || !('IntersectionObserver' in window)) return;

        this.sticky = sticky;
        document.body.appendChild(sticky);

        // Aparece cuando el botón principal ya quedó arriba (no antes de llegar a él)
        // y se esconde al llegar al pie de página, para no tapar sus enlaces.
        const footer = document.querySelector('.page-wrapper > footer') || document.querySelector('footer');
        let ctaAbove = false;
        let footerVisible = false;

        this.observer = new IntersectionObserver((entries) => {
          entries.forEach((entry) => {
            if (entry.target === cta) {
              ctaAbove = !entry.isIntersecting && entry.boundingClientRect.top < 0;
            } else {
              footerVisible = entry.isIntersecting;
            }
          });
          const show = ctaAbove && !footerVisible;
          sticky.classList.toggle('is-visible', show);
          document.body.classList.toggle('togo-has-sticky', show);
        });
        this.observer.observe(cta);
        if (footer) this.observer.observe(footer);
      }
    }

    customElements.define('togo-buy-box', TogoBuyBox);
  })();

  } catch(e) { console.error(e); }
})();
})();
